<template>
  <div class="profile-breakdowns">
    <BreakdownSectionComponent
      v-for="section in sections"
      :key="section.key"
      :title="section.title"
      :entries="section.entries"
      :total="profile.planned_mwh"
      :data-breakdown="section.key"
    />
  </div>
</template>

<script setup lang="ts">
import type { DeliveryProfile } from "@/forwards2/deals/deliveryProfile";
import {
  breakdownGroups,
  volumeByPeriod,
} from "@/forwards2/picker/productionBreakdown";
import BreakdownSectionComponent from "@/inventory_selection/BreakdownSectionComponent.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

/**
 * A delivery profile as the inventory pages' breakdown sections: its production periods, then the
 * volume picker's summary groups of the backing mandates' qualities, every row a share of the planned
 * volume. An ecolabel no backing mandate holds shows as 0, as on the inventory pages.
 *
 * The grid fits as many sections per row as the width allows, down to one in a narrow card.
 */
const props = defineProps<{
  profile: DeliveryProfile;
}>();

const { t } = useI18n();

const sections = computed(() => [
  {
    key: "vintage",
    title: t("forwards.picker.summary.by_period"),
    entries: volumeByPeriod(props.profile.by_period),
  },
  ...breakdownGroups(props.profile.mandates, props.profile.unbacked_mwh, t),
]);
</script>

<style scoped lang="scss">
.profile-breakdowns {
  display: grid;
  // min() keeps a column narrower than one section from scrolling sideways.
  grid-template-columns: repeat(auto-fill, minmax(min(220px, 100%), 1fr));
  gap: 0.75rem;
}
</style>
